<template>

  <div class="markup">
    <div class="markup__subtitle markup__subtitle_head">Формат In-Read Banner</div>
    <banners-article></banners-article>
  </div>

</template>

<script>
import bannersArticle from '@/components/documentation/bannersArticle.vue';

export default {
  name: 'inreadBanner',
  components: {
    bannersArticle,
  },
  data() {
    return {};
  },
};
</script>

<style scoped lang='stylus'>
@import '../../../styles/main.styl'
@import '../../../styles/documentation_article_markup.styl'
</style>
